import { JSONSchema7 } from 'json-schema';
import { PagePermissionLevel } from '../../Shared/Enums/pagePermissionLevel';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import getPagePermissionForRole from '../../Shared/jsonSchemaUtilities/getPagePermissionForRole';
import PageValidState from '../../Shared/pageValidState';
import { WorkflowEngineState } from '../workflowEngineReducer';

export default (state: WorkflowEngineState) => {
  const updatedState: PageValidState[] = [],
    totalPages = state.pages.length;
  let currentPage = null;
  const role = state.role;
  let anyPageValid = false;
  let lastEditablePageId = null;
  for (let pageId = 0; pageId < totalPages; pageId++) {
    const page = state.pages[pageId],
      pageStatus = state.workflowData[pageId][`${page.id}-pageValid`];
    const pageSchema = (page.schema.properties as JSONSchema7Properties)[
      'page'
    ] as JSONSchema7;
    if (pageStatus) {
      anyPageValid = true;
    }
    const pagePermissionLevel = getPagePermissionForRole(pageSchema, role);
    const isPageReadOnly = pagePermissionLevel === PagePermissionLevel.ReadOnly;
    const isEditable = pagePermissionLevel === PagePermissionLevel.Edit;
    if (currentPage === null && !pageStatus && !isPageReadOnly && isEditable) {
      currentPage = pageId;
    }
    if (isEditable) {
      lastEditablePageId = pageId;
    }

    updatedState.push({
      id: page.id,
      valid: pageStatus ? (pageStatus as boolean) : null
    });
  }

  if (currentPage === null) {
    state.currentPage = lastEditablePageId ? lastEditablePageId : 0;
  } else if (anyPageValid) {
    state.currentPage = currentPage;
  }

  state.pagesValidState = updatedState;
  return { ...state };
};
